module.exports = __webpack_public_path__ + "static/media/instag.aec4f615.png";